import { Box, Slide } from "@material-ui/core"
import React, { useEffect, useRef, useState } from "react"
import { EnumFasesSacola } from "../../../cardapio-sacola";
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario";
import { FormularioEndereco } from "./components/formulario-endereco/formulario-endereco";
import { SelecionarEndereco } from "./components/selecionar-endereco/selecionar-endereco";
import { useCardapioDadosStore } from "services/store/cardapio-dados-store";
import { usePedidoWhatsapp } from "services/hooks/pedido-whatsapp";
import { useDadosDeliveryStore } from "services/store/dados-delivery";
import { PessoaEnderecoModel } from "api/cardapio/models/pessoa/pessoa-model";
import { EnumOpcoesDelivery } from "storage";
import { usePedidos } from "services/providers/pedidos-provider";
import { useNotificacoes } from "components";
import { CircularLoading } from "components/utils/circular-loading";

export type TInformarEnderecoProps = {
    faseSacola: EnumFasesSacola;
    fecharSacola: () => void;
    onClickProximaFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    onClickVoltarFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    foiAbertoSacola: React.MutableRefObject<boolean>
    voltarParaFaseFinalizarPedido: React.MutableRefObject<boolean>
}

export const InformarEndereco = ({
    faseSacola,
    fecharSacola,
    onClickProximaFase,
    onClickVoltarFase,
    foiAbertoSacola,
    voltarParaFaseFinalizarPedido
}: TInformarEnderecoProps) => {
    const faseInformarEndereco = faseSacola === EnumFasesSacola.InformarEndereco
    const nextOrBack = useRef<0 | 1>(1)
    const { pessoa } = usePessoaUsuarioStore()
    const { enderecoDelivery, setTipoDelivery, setEnderecoDelivery } = useDadosDeliveryStore()
    const cardapioDados = useCardapioDadosStore(state => state.cardapioDados)
    const deliveryHabilitado = cardapioDados?.configuracoesDelivery?.deliveryHabilitado ?? false
    const [preencherFormulario, setPreencherFormulario] = useState<boolean>(() => pessoa ? pessoa?.enderecos?.length === 0 : true)
    const [endereco, setEndereco] = useState<PessoaEnderecoModel | undefined>(() => enderecoDelivery || new PessoaEnderecoModel())
    const { fazerPedidoWhatsApp } = usePedidoWhatsapp()
    const { addOuAttProdutoEntrega, carregando, removerItemEntregaSacola } = usePedidos()
    const { showErrorMessage } = useNotificacoes()

    useEffect(() => {
        if (faseInformarEndereco && !pessoa) {
            setEndereco(enderecoDelivery || new PessoaEnderecoModel())
        }
    }, [enderecoDelivery, faseInformarEndereco, pessoa])

    const proximaEtapaForm = () => {
        if (pessoa) {
            setPreencherFormulario(false)
            return
        }
        if (voltarParaFaseFinalizarPedido.current) {
            onClickProximaFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
            return
        }
        if (foiAbertoSacola.current) {
            onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
            foiAbertoSacola.current = false
            return
        }
        if (deliveryHabilitado) {
            onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
            return
        }
        fazerPedidoWhatsApp()
        fecharSacola()
    }

    const voltarForm = () => {
        if (pessoa) {
            setPreencherFormulario(false)
            return
        }
        if (foiAbertoSacola.current) {
            onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
            foiAbertoSacola.current = false
            return
        }
        if (voltarParaFaseFinalizarPedido.current) {
            onClickVoltarFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
            return
        }

        onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
    }

    const voltarSelecao = () => {
        if (voltarParaFaseFinalizarPedido.current) {
            onClickVoltarFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
            return
        }
        onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
    }

    const adicionarProdutoEntrega = async () => {
        const res = await addOuAttProdutoEntrega({
            nro: endereco?.numero || '',
            cpl: endereco?.complemento || '',
            bairro: endereco?.bairro || '',
            municipio: endereco?.xMun || '',
            uf: endereco?.uf || '',
            cep: endereco?.cep || '',
            documento: '',
            lgr: endereco?.logradouro || '',
            nome: '',
            referencia: '',
            telefone: '',
            tipo: EnumOpcoesDelivery.Entrega,
        })
        if (res === false) {
            throw new Error('O endereço informado está fora do raio da área de entrega.')
        }
    }

    const confirmarEndereco = async (tipoDelivery: EnumOpcoesDelivery) => {
        try {
            setTipoDelivery(tipoDelivery)
            setEnderecoDelivery(endereco)
            if (foiAbertoSacola.current) {
                if (tipoDelivery === EnumOpcoesDelivery.Entrega) {
                    await adicionarProdutoEntrega()
                } else {
                    removerItemEntregaSacola()
                }
                onClickVoltarFase(nextOrBack, EnumFasesSacola.Sacola)
                foiAbertoSacola.current = false
                return
            }
            if (voltarParaFaseFinalizarPedido.current) {
                if (tipoDelivery === EnumOpcoesDelivery.Entrega) {
                    await adicionarProdutoEntrega()
                } else {
                    removerItemEntregaSacola()
                }
                onClickProximaFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
                return
            }
            if (deliveryHabilitado) {
                if (tipoDelivery === EnumOpcoesDelivery.Entrega) {
                    await adicionarProdutoEntrega()
                } else {
                    removerItemEntregaSacola()
                }
                onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
            }
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }

    return (
        <Slide direction={nextOrBack ? "left" : 'right'} mountOnEnter unmountOnExit in={faseInformarEndereco}>
            <Box height={"100%"} width="100%">
                {carregando && <CircularLoading tipo="FULLSIZED" />}
                {preencherFormulario ? (
                    <FormularioEndereco endereco={endereco || new PessoaEnderecoModel()} proximaEtapa={proximaEtapaForm} voltar={voltarForm} />
                ) : (
                    <SelecionarEndereco
                        enderecoSelecionado={endereco}
                        faseInformarEndereco={faseInformarEndereco}
                        setPreencherFormulario={setPreencherFormulario}
                        setEndereco={setEndereco}
                        voltar={voltarSelecao}
                        confirmarEndereco={confirmarEndereco}
                    />
                )}
            </Box>
        </Slide>
    )
}